module.exports = __webpack_public_path__ + "static/img/2.ea36803.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/8/zh/2.png
// module id = jf7e
// module chunks = 0